module.exports = require('./helpers/bundle-url').getBundleURL('13ph5') + "sunny.9f9bc85b.webp";